import { Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import classNames from "classnames";
import styles from "@/components/summaryCard/summaryIssueList.module.css";

export interface SummaryIssue {
  key: string;
  title: string;
  details: string[];
}

interface Props {
  issues: SummaryIssue[];
  severity?: "error" | "warning";
  heading?: string;
}

export default function SummaryIssueList({
  issues,
  severity = "error",
  heading,
}: Props) {
  if (issues.length === 0) return null;
  const SeverityIcon =
    severity === "error" ? ErrorOutlineIcon : WarningAmberOutlinedIcon;

  return (
    <div className={classNames(styles.issueSection, styles[severity])}>
      {heading && (
        <Typography className={styles.heading}>{heading}</Typography>
      )}
      <ul className={styles.issueList}>
        {issues.map((issue) => (
          <li key={issue.key} className={styles.issue}>
            <SeverityIcon className={styles.issueIcon} aria-hidden="true" />
            <div>
              <Typography className={styles.issueTitle}>
                {issue.title}
              </Typography>
              {issue.details.map((detail, index) => (
                <Typography
                  key={`${index}-${detail}`}
                  className={styles.issueDetail}
                >
                  {detail}
                </Typography>
              ))}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
